import React from "react";
import Background from "../../assets/images/page_not_found.png";

function NoPageFound() {
  return (
    <div className="full-container">
      <div className="fw600 fs36 text-notFound">Page not found</div>
      <div className="mt23" style={{ maxWidth: 863, minHeight: 454 }}>
        <img
          src={Background}
          alt=""
          style={{ width: "100%", height: "100%" }}
        />
      </div>
    </div>
  );
}

export default NoPageFound;
